<template>
    <div class="loading">
        <StaticSpinner />
    </div>
</template>

<script lang="ts" setup>
    import StaticSpinner from '@/components/common/StaticSpinner.vue';
</script>

<style lang="scss" scoped>
.loading {
    display: flex;
    height: 144px;
    flex-direction: column;
    flex-shrink: 0;
    align-items: center;
    align-self: stretch;
    justify-content: center;
    padding: var(--spacers-xxl) 0;
    background-color: var(--indigo-100);
    border-radius: var(--borderRadius-md);
}
</style>
